const rutasContexto = [

  // carros
  // cerramientoUrbanismo * no se usa
  // comunal
  // duplicadores
  // urbanismoSauces
  // urbanismoFelicidad
  // vegetacionFelicidad
  // edificiosVecinos * no tiene textura

  //Modelos

  {
    name: "modelo_carros",
    type: "gltfModel",
    path: "modelos/contexto/CARROS_FL.gltf",
  },
  {
    name: "modelo_comunal",
    type: "gltfModel",
    path: "modelos/contexto/COMUNAL_FL.gltf",
  },
  {
    name: "modelo_duplicadores",
    type: "gltfModel",
    path: "modelos/contexto/DUPLICADORES_FL.gltf",
  },
  {
    name: "modelo_urbanismoFelicidad",
    type: "gltfModel",
    path: "modelos/contexto/URBANISMO LA FELICIDAD_FL.gltf",
  },
  {
    name: "modelo_urbanismoSauces",
    type: "gltfModel",
    path: "modelos/contexto/URBANISMO SAUCES_FL.gltf",
  },
  {
    name: "modelo_vegetacionFelicidad",
    type: "gltfModel",
    path: "modelos/contexto/VEGETACION LA FELICIDAD_FL.gltf",
  },
  {
    name: "modelo_edificiosVecinos",
    type: "gltfModel",
    path: "modelos/contexto/EDIFICIOS_VECINOS.gltf",
  },
  //Texturas  
  {
    name: "text_carros",
    type: "texture",
    path: "texturas/contexto/CARROS_FL_Corona_Diffuse.webp",
  },
  /*{
    name: "text_cerramientoUrbanismo",
    type: "texture",
    path: "texturas/contexto/CERRAMIENTO URBANISMO_FL_Corona_Diffuse.webp",
  },
  {
    name: "text_cerramientoUrbanismo_alpha",
    type: "texture",
    path: "texturas/contexto/CERRAMIENTO URBANISMO_FL_Corona_Alpha.webp",
  },*/
  {
    name: "text_comunal",
    type: "texture",
    path: "texturas/contexto/COMUNAL_FL_Corona_Diffuse.webp",
  },
  {
    name: "text_duplicadores",
    type: "texture",
    path: "texturas/contexto/DUPLICADORES_FL_Corona_Diffuse.webp",
  },
  {
    name: "text_urbanismoSauces",
    type: "texture",
    path: "texturas/contexto/URBANISMO SAUCES_FL_Corona_Diffuse.webp",
  },
  {
    name: "text_urbanismoFelicidad",
    type: "texture",
    path: "texturas/contexto/URBANISMO LA FELICIDAD_FL_Corona_Diffuse.webp",
  },
  {
    name: "text_vegetacionFelicidad",
    type: "texture",
    path: "texturas/contexto/VEGETACION LA FELICIDAD_FL_Corona_Diffuse.webp",
  },
];

export default rutasContexto;
